<div class="table-responsive recombination-table-group">
  <form [formGroup]="recombinationGroup" novalidate>
    <table class="table fm-table__interactive">
      <caption class="recombination-caption">
        <div>
          <span class="recombination-group-number--section-title"
            >Group {{ recombinationTableGroup.recombinationCollatGroup }}</span
          >
          <span class="recombination-group-number--descriptive">
            - Recombination {{ recombinationTableGroup.recombinationNumber }}</span
          >
          <button
            type="button"
            class="button fm-tertiary-button clear-button"
            (click)="clearGroup()"
          >
            CLEAR
          </button>
        </div>
      </caption>
      <thead>
        <tr>
          <th class="recombination-table-td">CLASS/POOL</th>
          <th class="recombination-table-td">CUSIP</th>
          <th class="recombination-table-td">COUPON</th>
          <th class="th_column--is-numeric recombination-table-td">ORIGINAL BALANCE</th>
          <!--
        <th class="th_column&#45;&#45;is-numeric">FACTOR</th>
        <th class="th_column&#45;&#45;is-numeric">CURRENT BALANCE EXCHANGED</th>
        <th>DELAY?</th>
        <th>PRINCIPAL TYPE</th>
        <th>INTEREST TYPE</th>
        <th class="th_column&#45;&#45;is-numeric">COUPON</th>
        <th>FINAL DIST. DATE</th>
        -->
          <th class="recombination-table-td">BALANCE TO FANNIE MAE</th>
          <th class="recombination-table-td">BALANCE TO DEALER</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let bond of recombinationGroup.get('recombinationRows')['controls'];
            let j = index;
            trackBy: trackByIdentity
          "
        >
          <td
            [ngClass]="{
              rcrBondClass: bond.controls.rcrClass.value != null,
              remicBondClass: bond.controls.remicClass.value != null,
              'bond--paid-off': bond.controls.factor.value === 0,
            }"
          >
            <ng-container
              *ngIf="
                bond.controls.rcrClass.value != null && recombinationTableRowExchangeType === 'SMBS'
              "
            >
              COMBO: {{ bond.controls.rcrClass.value }}
              <ng-container *ngIf="bond.controls.factor.value === 0">
                <span class="bond--paid-off">
                  <i
                    class="fa fa-exclamation-circle bonds-disabled-message tooltip-error"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="The bond has been paid off. It will not be included as part of this exchange"
                  >
                  </i>
                </span>
              </ng-container>
            </ng-container>
            <ng-container
              *ngIf="
                bond.controls.rcrClass.value != null &&
                recombinationTableRowExchangeType === 'REMIC'
              "
            >
              RCR: {{ bond.controls.rcrClass.value }}
              <ng-container *ngIf="bond.controls.factor.value === 0">
                <span class="bond--paid-off">
                  <i
                    class="fa fa-exclamation-circle bonds-disabled-message tooltip-error"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="The bond has been paid off. It will not be included as part of this exchange"
                  >
                  </i>
                </span>
              </ng-container>
            </ng-container>
            <ng-container
              *ngIf="
                bond.controls.remicClass.value != null &&
                recombinationTableRowExchangeType === 'SMBS'
              "
            >
              SMBS: {{ bond.controls.remicClass.value }}
              <ng-container *ngIf="bond.controls.factor.value === 0">
                <span class="bond--paid-off">
                  <i
                    class="fa fa-exclamation-circle bonds-disabled-message tooltip-error"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="The bond has been paid off. It will not be included as part of this exchange"
                  >
                  </i>
                </span>
              </ng-container>
            </ng-container>
            <ng-container
              *ngIf="
                bond.controls.remicClass.value != null &&
                recombinationTableRowExchangeType === 'REMIC'
              "
            >
              REMIC: {{ bond.controls.remicClass.value }}
              <ng-container *ngIf="bond.controls.factor.value === 0">
                <span class="bond--paid-off">
                  <i
                    class="fa fa-exclamation-circle bonds-disabled-message tooltip-error"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="The bond has been paid off. It will not be included as part of this exchange"
                  >
                  </i>
                </span>
              </ng-container>
            </ng-container>
          </td>
          <td [ngClass]="{ 'bond--paid-off': bond.controls.factor.value === 0 }">
            {{ bond.controls.cusip.value }}
          </td>
          <td [ngClass]="{ 'bond--paid-off': bond.controls.factor.value === 0 }">
            {{ bond.controls.interestRate.value | number: '1.5-5' }}
          </td>
          <td
            [ngClass]="{ 'bond--paid-off': bond.controls.factor.value === 0 }"
            class="td_cell--is-numeric"
          >
            {{ bond.controls.exchangeOriginalFace.value | currency: 'USD' : 'symbol' : '1.0' }}
          </td>
          <td
            class="toFannieMae form-group"
            [class.hasBondErrorTooltip]="
              bond.controls.originalFaceToFNMA.hasError('invalidBondExchange')
            "
          >
            <div class="input-group-container">
              <ng-container
                *ngIf="bond.controls.originalFaceToFNMA.hasError('invalidBondExchange')"
              >
                <i
                  class="fa fa-exclamation-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon__error-icon tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="The amount entered exceeds the allowed balance. Please try again"
                ></i>
              </ng-container>
              <span
                class="currency-addon"
                [ngClass]="{
                  'currency-disabled':
                    bond.controls.originalFaceToFNMA.hasError('invalidBondExchange') ||
                    bond.controls.originalFaceToFNMA.disabled,
                }"
                >$</span
              >
              <input
                type="text"
                [textMask]="{ mask: numberMask }"
                class="{{ bond.controls.id.value }} input-group--bonds linear__user__flow"
                [ngClass]="{ 'bond--paid-off': bond.controls.factor.value === 0 }"
                [class.hasBondError]="
                  bond.controls.originalFaceToFNMA.hasError('invalidBondExchange')
                "
                [formControl]="bond.controls.originalFaceToFNMA"
                [(ngModel)]="recombinationTableGroup.recombinationRows[j].origFaceToFNMA"
                (keydown.enter)="
                  captureBondExchangeEvent($event, bond.controls.originalFaceToFNMA, j)
                "
                (blur)="captureBondExchangeEvent($event, bond.controls.originalFaceToFNMA, j)"
              />
              <ng-container
                *ngIf="!bond.controls.originalFaceToFNMA.disabled && isAvailableToIncrement"
              >
                <div
                  class="input-group-container-addon input-group-container-addon--right input-group-container-addon--top input-group-container-addon__button--vertical"
                >
                  <button
                    class="button--number increment-up"
                    [disabled]="
                      bond.controls.originalFaceToFNMA.hasError('invalidBondExchangeTooHigh')
                    "
                    type="button"
                    (click)="incrementBond(j, 'originalFaceToFNMA')"
                  >
                    <i class="fa fa-caret-up"></i>
                  </button>
                  <button
                    class="button--number decrement-down"
                    [disabled]="
                      bond.controls.originalFaceToFNMA.hasError('invalidBondExchangeTooLow')
                    "
                    type="button"
                    (click)="decrementBond(j, 'originalFaceToFNMA')"
                  >
                    <i class="fa fa-caret-down"></i>
                  </button>
                </div>
              </ng-container>
            </div>
          </td>
          <td
            class="toDealer form-group"
            [class.hasBondErrorTooltip]="
              bond.controls.originalFaceToDealer.hasError('invalidBondExchange')
            "
          >
            <div class="input-group-container">
              <ng-container
                *ngIf="bond.controls.originalFaceToDealer.hasError('invalidBondExchange')"
              >
                <i
                  class="fa fa-exclamation-circle input-group-container-addon input-group-container-addon--disabled input-group-container-addon__error-icon tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="The amount entered exceeds the allowed balance. Please try again"
                ></i>
              </ng-container>
              <span
                class="currency-addon"
                [ngClass]="{
                  'currency-disabled':
                    bond.controls.originalFaceToDealer.hasError('invalidBondExchange') ||
                    bond.controls.originalFaceToDealer.disabled,
                }"
                >$</span
              >
              <input
                type="text"
                [textMask]="{ mask: numberMask }"
                [ngClass]="{ 'bond--paid-off': bond.controls.factor.value === 0 }"
                class="{{ bond.controls.id.value }} input-group--bonds linear__user__flow"
                [class.hasBondError]="
                  bond.controls.originalFaceToDealer.hasError('invalidBondExchange')
                "
                [formControl]="bond.controls.originalFaceToDealer"
                [(ngModel)]="recombinationTableGroup.recombinationRows[j].origFaceToDealer"
                (keydown.enter)="
                  captureBondExchangeEvent($event, bond.controls.originalFaceToDealer, j)
                "
                (blur)="captureBondExchangeEvent($event, bond.controls.originalFaceToDealer, j)"
              />
              <ng-container
                *ngIf="!bond.controls.originalFaceToDealer.disabled && isAvailableToIncrement"
              >
                <div
                  class="input-group-container-addon input-group-container-addon--right input-group-container-addon--top input-group-container-addon__button--vertical"
                >
                  <button
                    class="button--number increment-up"
                    [disabled]="
                      bond.controls.originalFaceToDealer.hasError('invalidBondExchangeTooHigh')
                    "
                    type="button"
                    (click)="incrementBond(j, 'originalFaceToDealer')"
                  >
                    <i class="fa fa-caret-up"></i>
                  </button>
                  <button
                    class="button--number decrement-down"
                    [disabled]="
                      bond.controls.originalFaceToDealer.hasError('invalidBondExchangeTooLow')
                    "
                    type="button"
                    (click)="decrementBond(j, 'originalFaceToDealer')"
                  >
                    <i class="fa fa-caret-down"></i>
                  </button>
                </div>
              </ng-container>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </form>
</div>
